import { Component } from 'react';
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridgeWeak } from '@atlassian/jira-common-bridge/src';
import type { ChangeFavoritePayload } from '../../model/types.tsx';
import type { Props, FavoriteChangeCallback } from './types.tsx';

// eslint-disable-next-line jira/react/no-class-components
export default class ImperativeApi extends Component<Props> {
	static defaultProps = {
		items: {
			boards: {},
			filters: {},
			dashboards: {},
			issues: {},
			projects: {},
			queues: {},
		},
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onAddClearImperativeApiCallback: () => {},
	};

	constructor() {
		// @ts-expect-error - TS2554 - Expected 1-2 arguments, but got 0.
		super();
		// eslint-disable-next-line jira/wrm/no-load-bridge
		loadBridgeWeak({
			name: 'jira/favouriteItems/bridge',
		}).then((bridge) => {
			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			bridge(this.getImperativeAPI());
		});
	}

	shouldComponentUpdate(nextProps: Props) {
		return this.props.items !== nextProps.items;
	}

	componentDidUpdate() {
		if (!this.props.items) return;

		this.props.callbackRegistry.run(this.props.items);
	}

	componentWillUnmount() {
		this.props.callbackRegistry.clear();
	}

	getImperativeAPI() {
		return {
			// Update a favorite in Jira-Frontend (from Monolith)
			changeFavourite: async (item: ChangeFavoritePayload) => this.props.changeFavorite(item),

			// Register a callback that gets executed in Monolith when a value in Jira-Frontend gets changed
			registerFavouriteChangeCallback: (callback: FavoriteChangeCallback) =>
				this.props.callbackRegistry.add(callback),

			unregisterFavouriteChangeCallback: (callback: FavoriteChangeCallback) =>
				this.props.callbackRegistry.remove(callback),
		};
	}

	render() {
		return null;
	}
}
